<template>
  
  <div class="confirm layered" :class="{loading: loading}">

    <div class="content">

      <span>Sei sicuro di voler eliminare queste credenziali?</span>

      <div class="actions">

        <button class="belt-btn-small" @click="close()">No</button>
        <button class="belt-btn-small" @click="deleteCredentials()">Si</button>

      </div>

    </div>

  </div>

</template>

<script>
export default{

  props: ['credential'],

  data: function(){

    return {
      loading: false
    }

  },

  methods: {

    close: function(){
      this.$parent.delete_credential = false;
    },

    deleteCredentials: function(){

      var vue = this;
      vue.loading = true;

      axios({
        method: "post",
        url: window.location.origin + '/data/delete-credentials',
        data: {
          id: vue.credential.id
        }
      })
      .then(res => {

        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

        vue.splitCredential(vue.credential.id);

      })
      .catch(err => {
          console.log(err.response.data)
      })
      .then(() =>{
        vue.loading = false;
      })

    },

    splitCredential: function(){

      this.$parent.$destroy();

    }

  }

}
</script>

<style scoped>
.confirm{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--background-gray);
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm .actions{
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm .actions button{
  margin: 1em;
  width: 100px;
  text-align: center;
}
</style>